import { ScenarioTemplateBuilderPage } from '@/pages/scenario-template-builder'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/templates/editor/$template_id')({
	component: ScenarioTemplateBuilderPage,
})
